import { ReactNode } from 'react'
import { Button } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'
import PixyMarkdown from '@/components/markdown/PixyMarkdown'

type DescriptionDialogProps = {
  overlay: OverlayState
  title: ReactNode
  subtitle: ReactNode
  description: string
  fullScreen?: boolean
  onExited?: () => void
}

export default function DescriptionDialog({
  overlay,
  title,
  subtitle,
  description,
  fullScreen,
  onExited,
}: DescriptionDialogProps) {
  return (
    <Dialog
      title={title}
      subtitle={subtitle}
      {...overlay}
      fullScreen={fullScreen}
      TransitionProps={{
        onExited: () => {
          onExited?.()
        },
      }}
    >
      <DialogContent>
        <PixyMarkdown>{description}</PixyMarkdown>
      </DialogContent>
      <DialogFooter>
        <Button onClick={overlay.close}>Close</Button>
      </DialogFooter>
    </Dialog>
  )
}
